/* FFC Pack configurator — zbiera warianty i ilości składników pakietu.

   Sedno: pakiet z 5 koszulkami i 2 bluzami ma dołożyć 5 koszulek i 2 bluzy.
   Sam produkt-pakiet NIE trafia do koszyka -- jest nośnikiem ceny i opisu,
   a klient płaci za realne sztuki, które da się spersonalizować i wysłać.

   Wybór jest rozbity na kolor i rozmiar. Prawdą o tym, co istnieje, są dane
   wariantów wstawione obok wiersza jako JSON: po zmianie koloru druga lista
   przebudowuje się z nich, a rozmiar niedostępny w tym kolorze wychodzi
   wyłączony od razu, zamiast dopiero jako błąd przy dodawaniu do koszyka.

   Linie komponentów KWALIFIKUJĄCYCH SIĘ do personalizacji (metafieldy
   `custom.dtf_eligible` / `custom.embroidery_eligible`, flaga
   data-perso-eligible z sekcji) dostają `_fp_pending: yes`, czyli znacznik,
   na którym stoi moduł personalizacji w koszyku -- dzięki temu po dodaniu
   pakietu klient od razu widzi tam krok "dokończ personalizację", bez
   osobnej integracji. Komponent bez eligibility wchodzi jako gładki.

   Pakiety `ffc-pack-v2` wysyłają wybór do kontrolowanej bramki IONOS. Bramka
   pobiera z Shopify zaufany metafield, cenę i świeży stan, tworzy Draft Order
   z rzeczywistymi liniami magazynowymi i zwraca wyłącznie link do bezpiecznego
   checkoutu Shopify. Starsze pakiety zachowują atomowe dodawanie wielu pozycji
   przez /cart/add.js. */
(function () {
  'use strict';

  function buildGroupedItems(selectionRows, packTitle, packGroup) {
    var grouped = {};
    var items = [];

    for (var rowIndex = 0; rowIndex < selectionRows.length; rowIndex++) {
      var selectionRow = selectionRows[rowIndex];
      if (selectionRow.variantIds.length !== selectionRow.quantity) {
        return { error: 'Choose an available colour and size for every garment in the pack.' };
      }
      var props = {
        _pack: packTitle,
        _fp_pack_group: packGroup,
        _fp_pack_dtf_entitled: selectionRow.dtfIncluded ? 'yes' : 'no',
        _fp_pack_dtf_included: selectionRow.dtfIncluded ? 'yes' : 'no'
      };
      if (selectionRow.personalisable) props._fp_pending = 'yes';

      for (var choiceIndex = 0; choiceIndex < selectionRow.variantIds.length; choiceIndex++) {
        var id = selectionRow.variantIds[choiceIndex];
        if (!id) return { error: 'Choose an available colour and size for every garment in the pack.' };
        var groupKey = id + '|' + (props._fp_pending || 'blank') + '|' + props._fp_pack_dtf_entitled;
        if (!grouped[groupKey]) {
          grouped[groupKey] = { id: Number(id), quantity: 0, properties: props };
        }
        grouped[groupKey].quantity += 1;
      }
    }

    Object.keys(grouped).forEach(function (key) { items.push(grouped[key]); });
    return items.length ? { items: items } : { error: 'This pack has no items to add.' };
  }

  function buildTransformParentItem(selectionRows, parentVariantId, packTitle, packGroup) {
    var tokens = [];
    var maxChunkLength = 220;
    var maxChunks = 16;

    if (!/^\d+$/.test(String(parentVariantId || ''))) {
      return { error: 'This pack is not ready to add yet.' };
    }

    for (var rowIndex = 0; rowIndex < selectionRows.length; rowIndex++) {
      var selectionRow = selectionRows[rowIndex];
      if (selectionRow.variantIds.length !== selectionRow.quantity) {
        return { error: 'Choose an available colour and size for every garment in the pack.' };
      }

      var quantities = {};
      for (var choiceIndex = 0; choiceIndex < selectionRow.variantIds.length; choiceIndex++) {
        var variantId = String(selectionRow.variantIds[choiceIndex] || '');
        if (!/^\d+$/.test(variantId)) {
          return { error: 'Choose an available colour and size for every garment in the pack.' };
        }
        quantities[variantId] = (quantities[variantId] || 0) + 1;
      }

      Object.keys(quantities).forEach(function (variantId) {
        tokens.push(rowIndex + '.' + variantId + '.' + quantities[variantId]);
      });
    }
    if (!tokens.length) return { error: 'This pack has no items to add.' };

    var chunks = [];
    var current = '';
    for (var tokenIndex = 0; tokenIndex < tokens.length; tokenIndex++) {
      var token = tokens[tokenIndex];
      var candidate = current ? current + ',' + token : token;
      if (candidate.length > maxChunkLength) {
        if (!current) return { error: 'This pack selection is too large.' };
        chunks.push(current);
        current = token;
      } else {
        current = candidate;
      }
    }
    if (current) chunks.push(current);
    if (chunks.length > maxChunks) {
      return { error: 'This pack selection is too large.' };
    }

    var properties = {
      _pack: packTitle,
      _fp_pack_group: packGroup,
      _fp_pack_transform: 'v1'
    };
    chunks.forEach(function (chunk, index) {
      properties['_fp_pc_' + index] = chunk;
    });

    return {
      items: [{ id: Number(parentVariantId), quantity: 1, properties: properties }]
    };
  }

  function boot() {
    var root = document.querySelector('[data-ffc-packcfg]');
    if (!root || root.dataset.ffcReady === 'true') return;
    root.dataset.ffcReady = 'true';

    var btn = root.querySelector('[data-pack-add]');
    var blankBtn = root.querySelector('[data-pack-blank]');
    var errEl = root.querySelector('[data-pack-error]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pack-row]'));
    var usesTransform = root.getAttribute('data-pack-transform') === 'true';
    var dynamicPricing = root.getAttribute('data-dynamic-pack-pricing') === 'true';
    var quoteSignature = '', quoteGeneration = 0, quotePending = false, packPricePence = null;
    var quoteTimer = null;
    function selectedPricingRows() {
      return rows.map(function (row, index) {
        var ids = typeof row.ffcVariantIds === 'function' ? row.ffcVariantIds()
          : Array.from(row.querySelectorAll('[data-pack-choice]'), function (choice) { return choice.getAttribute('data-variant-id'); });
        return { groupIndex: index, variantIds: ids.map(String) };
      });
    }
    function updatePackQuote(ready) {
      if (!dynamicPricing) return true;
      var selected = selectedPricingRows(), signature = ready ? JSON.stringify(selected) : '';
      if (signature && signature === quoteSignature) return !quotePending && Number.isInteger(packPricePence);
      quoteSignature = signature; quoteGeneration += 1; packPricePence = null;
      clearTimeout(quoteTimer); quotePending = !!signature;
      var generation = quoteGeneration, price = root.querySelector('.ffc-packcfg__price'), status = root.querySelector('[data-pack-price-status]');
      if (price) price.textContent = 'From ' + new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(Number(root.dataset.packFromPrice) / 100);
      if (status) status.textContent = signature ? 'Checking your selected pack price…' : 'Choose colours and sizes for your exact pack price.';
      if (!signature) return false;
      quoteTimer = setTimeout(function () {
        fetch(root.getAttribute('data-checkout-gateway'), {method:'POST',headers:{'Content-Type':'application/json','X-FFC-Checkout':'v1'},body:JSON.stringify({quoteOnly:true,requestId:newRequestId(),parentVariantId:String(root.getAttribute('data-parent-variant-id')),selectionRows:selected,personalisation:null})})
          .then(function (res) { return res.json().then(function (data) {if(!res.ok || !data.ok || data.quoteOnly !== true || data.currency !== 'GBP' || !data.pricing || !Number.isInteger(data.pricing.pricePence) || data.pricing.pricePence < 1) throw new Error(data.error || 'Could not check the pack price.');return data;}); })
          .then(function (data) {if(generation !== quoteGeneration)return;packPricePence=data.pricing.pricePence;quotePending=false;if(price)price.textContent=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(packPricePence/100);if(status)status.textContent='Your selected pack price, including one chest DTF logo per eligible garment.';syncAddAvailability();})
          .catch(function (error) {if(generation !== quoteGeneration)return;quotePending=false;if(status)status.textContent=error.message+' Change a selection to try again.';syncAddAvailability();});
      }, 250);
      return false;
    }


    function syncAddAvailability() {
      if (!btn || btn.getAttribute('data-adding') === 'true') return;
      var ready = rows.length > 0 && rows.every(function (row) {
        return row.getAttribute('data-selection-ready') === 'true';
      });
      ready = updatePackQuote(ready) && ready;
      [btn, blankBtn].forEach(function (button) {
        if (!button) return;
        button.disabled = !ready;
        button.setAttribute('aria-disabled', ready ? 'false' : 'true');
      });
    }

    root.addEventListener('ffc:pack-selection-change', syncAddAvailability);
    rows.forEach(setupRow);
    syncAddAvailability();
    setupLightbox(root);
    setupSpecDialogs(root);

    if (!btn) return;

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    // Buttons use type="button": native form submission cannot validate these fields.
    function validateChoices() {
      var valid = rows.length > 0;
      var firstInvalid = null;
      rows.forEach(function (row) {
        if (typeof row.ffcValidateSelection === 'function') row.ffcValidateSelection();
        if (row.getAttribute('data-selection-ready') !== 'true') valid = false;
        row.querySelectorAll('[data-pack-choice-size], [data-pack-choice-colour], [data-pack-all-colour]:not(:disabled), [data-pack-bulk-quantity]').forEach(function (field) {
          if (!field.checkValidity()) { valid = false; firstInvalid = firstInvalid || field; }
        });
      });
      if (firstInvalid) {
        var row = firstInvalid.closest('[data-pack-row]');
        var editor = row.querySelector('[data-pack-editor]');
        var toggle = row.querySelector('[data-pack-toggle]');
        if (editor) editor.hidden = false;
        if (toggle) { toggle.setAttribute('aria-expanded', 'true'); toggle.textContent = toggle.dataset.labelDone; }
        firstInvalid.focus();
        firstInvalid.reportValidity();
      }
      syncAddAvailability();
      return valid;
    }

    function collect() {
      if (!validateChoices()) return { error: root.dataset.chooseAllMessage || 'Choose an available size for every garment.' };
      var titleEl = root.querySelector('.ffc-packcfg__title');
      var packTitle = titleEl ? titleEl.textContent.trim() : 'FlexiFit pack';
      var packGroup = 'pack-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var selectionRows = [];
      for (var i = 0; i < rows.length; i++) {
        var qty = parseInt(rows[i].getAttribute('data-qty'), 10);
        qty = qty > 0 ? qty : 1;
        var choices = Array.prototype.slice.call(rows[i].querySelectorAll('[data-pack-choice]'));
        var variantIds = typeof rows[i].ffcVariantIds === 'function'
          ? rows[i].ffcVariantIds()
          : choices.map(function (choice) { return choice.getAttribute('data-variant-id'); });
        if (variantIds.length !== qty) {
          return { error: 'This pack is missing one or more garment selections.' };
        }
        // `_fp_pending` tylko dla komponentów z jawnym metafieldem eligibility
        // (data-perso-eligible z sekcji). Linii pending, ktorej produkt nie
        // kwalifikuje sie do personalizacji, koszyk nie umie ani dokonczyc,
        // ani wyczyscic — a bramka kasy blokuje KAZDA linie pending, wiec
        // taki komponent zablokowalby checkout bez wyjscia. Znaczniki pakietu
        // Znacznik entitlement jest osobny od aktualnego wyniku konfiguracji:
        // kurtka moze nalezec do pakietu, ale nie miec DTF w cenie. Rozdzielenie
        // tych stanow pozwala tez zachowac entitlement po opcji "Buy as blank".
        selectionRows.push({
          quantity: qty,
          personalisable: rows[i].getAttribute('data-perso-eligible') === 'true',
          dtfIncluded: rows[i].getAttribute('data-pack-dtf-included') === 'true',
          variantIds: variantIds
        });
      }
      if (usesTransform) {
        return {
          packTitle: packTitle,
          packGroup: packGroup,
          parentVariantId: root.getAttribute('data-parent-variant-id'),
          selectionRows: selectionRows
        };
      }
      return buildGroupedItems(selectionRows, packTitle, packGroup);
    }

    function newRequestId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      return Array.prototype.map.call(bytes, function (byte, index) {
        var value = byte.toString(16).padStart(2, '0');
        return ([4, 6, 8, 10].indexOf(index) > -1 ? '-' : '') + value;
      }).join('');
    }

    var gatewayRequestId = '';
    var gatewaySignature = '';

    function setGatewayBusy(busy, label) {
      [btn, blankBtn].forEach(function (button) {
        if (!button) return;
        button.disabled = busy;
        if (busy) button.setAttribute('data-adding', 'true');
        else button.removeAttribute('data-adding');
      });
      if (btn) btn.textContent = busy ? 'Preparing secure checkout…' : label;
    }

    function checkoutUrlAllowed(value) {
      try {
        var target = new URL(value);
        return target.protocol === 'https:' && ['flexifitclothing.co.uk', 'www.flexifitclothing.co.uk'].indexOf(target.hostname) > -1;
      } catch (e) {
        return false;
      }
    }

    function submitGateway(selection, personalisation) {
      if (!validateChoices()) { showError(root.dataset.chooseAllMessage); return; }
      var currentIds = rows.map(function (row) {
        return typeof row.ffcVariantIds === 'function'
          ? row.ffcVariantIds()
          : Array.from(row.querySelectorAll('[data-pack-choice]'), function (choice) { return choice.getAttribute('data-variant-id'); });
      });
      if (JSON.stringify(currentIds) !== JSON.stringify(selection.selectionRows.map(function (row) { return row.variantIds; }))) {
        showError(root.dataset.changedSelectionMessage || 'Your garment selection changed. Open personalisation again.');
        return;
      }
      var endpoint = (root.getAttribute('data-checkout-gateway') || '').trim();
      if (!/^https:\/\//i.test(endpoint)) {
        showError('Secure pack checkout is not configured yet.');
        return;
      }
      var requestCore = {
        parentVariantId: String(selection.parentVariantId || ''),
        selectionRows: selection.selectionRows.map(function (row, index) {
          return { groupIndex: index, variantIds: row.variantIds.map(String) };
        }),
        personalisation: personalisation || null
      };
      if (dynamicPricing) {
        if (!Number.isInteger(packPricePence) || quotePending || quoteSignature !== JSON.stringify(selectedPricingRows())) {showError('Review the current selected pack price before continuing.');return;}
        requestCore.expectedPackPricePence = packPricePence;
      }
      var signature = JSON.stringify(requestCore);
      if (!gatewayRequestId || gatewaySignature !== signature) {
        gatewayRequestId = newRequestId();
        gatewaySignature = signature;
      }
      var label = btn.textContent;
      setGatewayBusy(true, label);

      fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-FFC-Checkout': 'v1'
        },
        body: JSON.stringify(Object.assign({ requestId: gatewayRequestId }, requestCore))
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok || !data.ok) {
              throw new Error(data.error || 'Could not prepare secure checkout.');
            }
            return data;
          });
        })
        .then(function (data) {
          if (!checkoutUrlAllowed(data.checkoutUrl)) {
            throw new Error('Shopify returned an unexpected checkout link.');
          }
          window.location.assign(data.checkoutUrl);
        })
        .catch(function (error) {
          setGatewayBusy(false, label);
          syncAddAvailability();
          showError(error.message || 'Could not prepare secure checkout.');
        });
    }

    function packPersonalisationOptions(selection) {
      var personalisableQty = 0;
      var includedDtfQty = 0;
      var allowEmbroidery = true;
      var colours = [];
      rows.forEach(function (row, rowIndex) {
        if (row.getAttribute('data-perso-eligible') !== 'true') return;
        personalisableQty += selection.selectionRows[rowIndex].quantity;
        if (row.getAttribute('data-pack-dtf-included') === 'true') {
          includedDtfQty += selection.selectionRows[rowIndex].quantity;
        }
        if (row.getAttribute('data-embroidery-eligible') !== 'true') {
          allowEmbroidery = false;
        }
        var selectedColours = typeof row.ffcSelectedColours === 'function'
          ? row.ffcSelectedColours()
          : Array.from(row.querySelectorAll('[data-pack-choice]'), function (choice) { return choice.getAttribute('data-colour') || ''; });
        selectedColours.forEach(function (colour) {
          if (colour && colours.indexOf(colour) === -1) colours.push(colour);
        });
      });
      return {
        qty: personalisableQty,
        includedDtfQty: includedDtfQty,
        allowEmbroidery: allowEmbroidery,
        colourName: colours[0] || '',
        colourOptions: colours
      };
    }

    if (usesTransform) {
      btn.addEventListener('click', function () {
        if (errEl) errEl.hidden = true;
        var selection = collect();
        if (selection.error) { showError(selection.error); return; }
        if (!window.FFCPersonalisation || typeof window.FFCPersonalisation.open !== 'function') {
          showError('The personalisation panel is still loading. Please try again.');
          return;
        }
        var options = packPersonalisationOptions(selection);
        options.onConfirm = function (_properties, _pricing, structured) {
          submitGateway(selection, structured);
        };
        window.FFCPersonalisation.open(options);
      });

      if (blankBtn) {
        blankBtn.addEventListener('click', function () {
          if (errEl) errEl.hidden = true;
          var selection = collect();
          if (selection.error) { showError(selection.error); return; }
          submitGateway(selection, null);
        });
      }
      return;
    }

    btn.addEventListener('click', function () {
      if (errEl) errEl.hidden = true;
      var payload = collect();
      if (payload.error) { showError(payload.error); return; }

      var label = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('data-adding', 'true');
      btn.textContent = 'Adding…';

      fetch(root.getAttribute('data-cart-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload.items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              // Shopify zwraca tu m.in. brak stanu magazynowego -- pokaż jego
              // własny komunikat, jest konkretniejszy niż cokolwiek generycznego.
              throw new Error(data.description || data.message || 'Could not add the pack.');
            }
            return data;
          });
        })
        .then(function () {
          // Rabat pakietowy nakładamy dopiero po udanym dodaniu, przez
          // /discount/KOD?redirect= -- Shopify sam przypina kod do sesji
          // koszyka i odsyła dalej, więc nie trzeba tu żadnego API ani
          // aplikacji. Puste ustawienie = zwykłe przejście do koszyka.
          var cartUrl = root.getAttribute('data-cart-url');
          var code = usesTransform ? '' : (root.getAttribute('data-discount') || '').trim();
          window.location.href = code
            ? '/discount/' + code + '?redirect=' + encodeURIComponent(cartUrl)
            : cartUrl;
        })
        .catch(function (e) {
          btn.removeAttribute('data-adding');
          btn.textContent = label;
          syncAddAvailability();
          showError(e.message);
        });
    });
  }

  function setupBulkRow(row, variants, target) {
    var choicesEl = row.querySelector('[data-pack-choices]');
    var optionEl = row.querySelector('[data-pack-option-values]');
    var optionData = {};
    try { optionData = optionEl ? JSON.parse(optionEl.textContent) : {}; } catch (e) { optionData = {}; }
    var highVariant = Number(optionData.count) > variants.length;
    var summaryEl = row.querySelector('[data-pack-summary]');
    var readyEl = row.querySelector('[data-pack-ready]');
    var stockEl = row.querySelector('[data-pack-stock]');
    var editor = row.querySelector('[data-pack-editor]');
    var toggle = row.querySelector('[data-pack-toggle]');
    var groupImg = row.querySelector('[data-pack-img]');
    var originalImage = groupImg ? { src: groupImg.getAttribute('src'), srcset: groupImg.getAttribute('srcset'), alt: groupImg.alt } : null;
    var productName = row.querySelector('.ffc-packrow__name');
    var colours = highVariant && optionData.colours && optionData.colours.length
      ? optionData.colours.map(function (value) { return value.name; })
      : unique(variants.map(function (v) { return v.colour; }).filter(Boolean));
    var sizes = highVariant && optionData.sizes && optionData.sizes.length
      ? optionData.sizes.map(function (value) { return value.name; })
      : unique(variants.map(function (v) { return v.size; }).filter(Boolean));
    var states = [{ colour: '', size: '', quantity: 0 }];
    var notice = '';
    var draftInvalid = false;

    function unique(values) {
      return values.filter(function (value, index) { return values.indexOf(value) === index; });
    }

    function escapeHtml(value) {
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    function live(v) { return v && v.available && Number(v.qty) > 0; }

    function variantFor(state) {
      if (!state || (colours.length && !state.colour) || (sizes.length && !state.size)) return null;
      return variants.filter(function (v) {
        return (!colours.length || v.colour === state.colour) && (!sizes.length || v.size === state.size);
      })[0] || null;
    }

    function colourImage(state) {
      if (colours.length && !state.colour) return '';
      var exact = variantFor(state);
      if (exact && exact.img) return exact.img;
      var match = variants.filter(function (v) { return v.colour === state.colour && v.img; })[0];
      if (match) return match.img;
      var option = (optionData.colours || []).filter(function (value) { return value.name === state.colour; })[0];
      return option && option.img ? option.img : '';
    }

    function total() {
      return states.reduce(function (sum, state) { return sum + state.quantity; }, 0);
    }

    function duplicate(index, variant) {
      return !!variant && states.some(function (state, other) {
        var selected = variantFor(state);
        return other !== index && state.quantity > 0 && selected && String(selected.id) === String(variant.id);
      });
    }

    function maximum(index) {
      var variant = variantFor(states[index]);
      if (!live(variant) || duplicate(index, variant)) return 0;
      return Math.max(0, Math.min(Number(variant.qty), target - total() + states[index].quantity));
    }

    function domQuantitiesValid() {
      var inputs = Array.from(choicesEl.querySelectorAll('[data-pack-bulk-quantity]'));
      return inputs.length === states.length && inputs.every(function (input, index) {
        return input.value !== '' && input.checkValidity() && Number(input.value) === states[index].quantity;
      });
    }

    function validSelection() {
      return !draftInvalid && domQuantitiesValid() && total() === target && states.every(function (state, index) {
        if (!state.quantity) return true;
        var variant = variantFor(state);
        return live(variant) && !duplicate(index, variant) && state.quantity <= Number(variant.qty);
      });
    }

    function notifyChange() {
      var event = document.createEvent('Event');
      event.initEvent('ffc:pack-selection-change', true, false);
      row.dispatchEvent(event);
    }

    function syncStatus() {
      var assigned = total();
      var remaining = target - assigned;
      var ready = validSelection();
      if (summaryEl) {
        summaryEl.textContent = 'Remaining: ' + remaining + ' of ' + target;
        summaryEl.hidden = false;
      }
      if (readyEl) {
        readyEl.textContent = assigned + '/' + target + ' assigned';
        readyEl.classList.toggle('is-incomplete', !ready);
      }
      if (stockEl) {
        stockEl.hidden = !notice;
        stockEl.textContent = notice;
        stockEl.className = 'ffc-packrow__stock ffc-packrow__stock--none';
      }
      row.setAttribute('data-selection-ready', ready ? 'true' : 'false');
      var add = choicesEl.querySelector('[data-pack-bulk-add]');
      if (add) add.disabled = remaining <= 0;
      Array.from(choicesEl.querySelectorAll('[data-pack-bulk-line]')).forEach(function (line, index) {
        var state = states[index];
        var limit = maximum(index);
        var input = line.querySelector('[data-pack-bulk-quantity]');
        var minus = line.querySelector('[data-pack-bulk-minus]');
        var plus = line.querySelector('[data-pack-bulk-plus]');
        if (input) input.max = String(limit);
        if (minus) minus.disabled = !state || state.quantity <= 0;
        if (plus) plus.disabled = !state || !variantFor(state) || state.quantity >= limit;
      });
      notifyChange();
    }

    function optionHtml(values, current, disabled) {
      return values.map(function (value) {
        var off = disabled(value);
        return '<option value="' + escapeHtml(value) + '"' + (value === current ? ' selected' : '') +
          (off ? ' disabled' : '') + '>' + escapeHtml(value + (off ? ' — out of stock or already selected' : '')) + '</option>';
      }).join('');
    }

    function render(focusId) {
      var product = productName ? productName.textContent.trim() : 'Garment';
      choicesEl.innerHTML = '<div class="ffc-packbulk__list">' + states.map(function (state, index) {
        var key = 'PackBulk-' + row.closest('[data-ffc-packcfg]').dataset.sectionId + '-' + row.dataset.rowIndex + '-' + index;
        var variant = variantFor(state);
        var photo = colourImage(state);
        var availableSizes = sizes.filter(function (size) {
          var candidate = variants.filter(function (v) { return v.colour === state.colour && v.size === size; })[0];
          return (highVariant ? (!candidate || live(candidate)) : live(candidate)) &&
            (!duplicate(index, candidate) || size === state.size);
        });
        var max = maximum(index);
        var alt = [product, state.colour].filter(Boolean).join(' — ');
        var preview = photo
          ? '<button type="button" class="ffc-packbulk__photo" data-pack-zoom aria-label="View ' + escapeHtml(alt) + '"><img src="' + escapeHtml(photo) + '" alt="' + escapeHtml(alt) + '" width="72" height="90" loading="lazy"></button>'
          : '<span class="ffc-packbulk__photo ffc-packbulk__photo--empty" aria-hidden="true">?</span>';
        var colourSelect = colours.length ? '<label class="ffc-packbulk__field" for="' + key + '-colour"><span>Colour</span><select id="' + key + '-colour" class="ffc-packrow__select" data-pack-bulk-colour><option value="">Choose a colour</option>' +
          optionHtml(colours, state.colour, function (colour) {
            var option = (optionData.colours || []).filter(function (value) { return value.name === colour; })[0];
            return highVariant && option ? option.available === false : !variants.some(function (v) { return v.colour === colour && live(v); });
          }) + '</select></label>' : '';
        var sizeSelect = sizes.length ? '<label class="ffc-packbulk__field" for="' + key + '-size"><span>Size</span><select id="' + key + '-size" class="ffc-packrow__select" data-pack-bulk-size' + (colours.length && !state.colour ? ' disabled' : '') + '><option value="">' + (state.colour ? 'Choose a size' : 'Choose colour first') + '</option>' +
          optionHtml(availableSizes, state.size, function () { return false; }) + '</select></label>' : '';
        return '<div class="ffc-packbulk__line" data-pack-bulk-line data-line-index="' + index + '">' + preview +
          '<div class="ffc-packbulk__fields">' + colourSelect + sizeSelect +
          '<label class="ffc-packbulk__field ffc-packbulk__quantity" for="' + key + '-quantity"><span>Quantity</span><span class="ffc-packbulk__stepper"><button type="button" data-pack-bulk-minus aria-label="Remove one from variant ' + (index + 1) + '"' + (state.quantity <= 0 ? ' disabled' : '') + '>−</button>' +
          '<input id="' + key + '-quantity" type="number" inputmode="numeric" min="0" max="' + max + '" step="1" value="' + state.quantity + '" data-pack-bulk-quantity' + (!variant || !live(variant) || state.loading ? ' disabled' : '') + ' aria-label="Quantity for variant ' + (index + 1) + '">' +
          '<button type="button" data-pack-bulk-plus aria-label="Add one to variant ' + (index + 1) + '"' + (state.quantity >= max || !variant ? ' disabled' : '') + '>+</button></span></label>' +
          '<button type="button" class="ffc-packbulk__remove" data-pack-bulk-remove>Remove</button></div>' +
          (state.loading ? '<span class="ffc-packbulk__loading">Checking availability…</span>' : '') + '</div>';
      }).join('') + '</div><button type="button" class="ffc-packbulk__add" data-pack-bulk-add>Add another colour or size</button>';
      var chosenColours = unique(states.filter(function (state) { return state.quantity > 0; }).map(function (state) { return state.colour; }).filter(Boolean));
      row.classList.toggle('has-mixed-colours', chosenColours.length > 1);
      if (groupImg && originalImage) {
        var sharedPhoto = chosenColours.length === 1 ? colourImage({ colour: chosenColours[0], size: '' }) : '';
        groupImg.src = sharedPhoto || originalImage.src;
        groupImg.alt = sharedPhoto ? product + ' — ' + chosenColours[0] : originalImage.alt;
        if (!sharedPhoto && originalImage.srcset) groupImg.setAttribute('srcset', originalImage.srcset);
        else groupImg.removeAttribute('srcset');
      }
      syncStatus();
      if (focusId) {
        var focused = document.getElementById(focusId);
        if (focused) focused.focus({ preventScroll: true });
      }
    }

    function lookupVariant(state) {
      if (!highVariant || !state.colour || !state.size || variantFor(state) || state.loading) return;
      var colour = (optionData.colours || []).filter(function (value) { return value.name === state.colour; })[0];
      var size = (optionData.sizes || []).filter(function (value) { return value.name === state.size; })[0];
      var ids = [];
      ids[Number(optionData.colourPosition) - 1] = colour && colour.id;
      ids[Number(optionData.sizePosition) - 1] = size && size.id;
      if (!optionData.url || ids.some(function (id) { return !Number(id); })) {
        notice = 'This colour and size could not be checked. Please choose another combination.';
        state.size = '';
        state.quantity = 0;
        render();
        return;
      }
      var requestedColour = state.colour;
      var requestedSize = state.size;
      var url = new URL(optionData.url, window.location.origin);
      url.searchParams.set('option_values', ids.join(','));
      url.searchParams.set('section_id', 'ffc-pack-variant-lookup');
      state.loading = true;
      render();
      fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Variant lookup failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var script = doc.querySelector('[data-pack-lookup]');
          if (!script) throw new Error('Variant lookup returned no data');
          var result = JSON.parse(script.textContent);
          if (states.indexOf(state) === -1 || state.colour !== requestedColour || state.size !== requestedSize) return;
          state.loading = false;
          if (!result || !Array.isArray(result.options) ||
              result.options[Number(optionData.colourPosition) - 1] !== requestedColour ||
              result.options[Number(optionData.sizePosition) - 1] !== requestedSize ||
              !/^\d+$/.test(String(result.id || ''))) {
            state.size = '';
            state.quantity = 0;
            notice = 'This colour and size is not available. Please choose another size.';
          } else {
            if (!variantFor(state)) variants.push({
              id: result.id, colour: requestedColour, size: requestedSize,
              available: !!result.available, qty: Number(result.qty) || 0, img: result.img || ''
            });
            if (!live(variantFor(state))) {
              state.size = '';
              state.quantity = 0;
              notice = 'This colour and size is out of stock. Please choose another size.';
            } else notice = '';
          }
          render();
        })
        .catch(function () {
          if (states.indexOf(state) === -1 || state.colour !== requestedColour || state.size !== requestedSize) return;
          state.loading = false;
          state.size = '';
          state.quantity = 0;
          notice = 'Could not check this colour and size. Please try again.';
          render();
        });
    }

    choicesEl.addEventListener('change', function (event) {
      var line = event.target.closest('[data-pack-bulk-line]');
      if (!line) return;
      var index = Number(line.getAttribute('data-line-index'));
      var state = states[index];
      var focusId = event.target.id;
      notice = '';
      if (event.target.matches('[data-pack-bulk-colour], [data-pack-bulk-size]')) {
        state.loading = false;
        if (event.target.matches('[data-pack-bulk-colour]')) state.colour = event.target.value;
        else state.size = event.target.value;
        var variant = variantFor(state);
        if ((variant && !live(variant)) || duplicate(index, variant) || state.quantity > maximum(index) || (!variant && !highVariant)) {
          if (event.target.matches('[data-pack-bulk-colour]')) state.size = '';
          else if (duplicate(index, variant)) state.size = '';
          if (state.quantity) {
            state.quantity = 0;
            notice = 'Choose a size and quantity for the changed variant. The previous quantity has returned to the pack.';
          } else if (duplicate(index, variant)) notice = 'This colour and size already has a row. Adjust its quantity there.';
        }
      } else if (event.target.matches('[data-pack-bulk-quantity]')) {
        if (!event.target.checkValidity()) {
          draftInvalid = true;
          notice = 'Enter a whole quantity within the remaining pack and available stock.';
          syncStatus();
          return;
        }
        state.quantity = Number(event.target.value);
        draftInvalid = false;
      }
      render(focusId);
      lookupVariant(state);
    });

    choicesEl.addEventListener('input', function (event) {
      if (!event.target.matches('[data-pack-bulk-quantity]')) return;
      var line = event.target.closest('[data-pack-bulk-line]');
      var index = Number(line.getAttribute('data-line-index'));
      var value = Number(event.target.value);
      var max = maximum(index);
      draftInvalid = event.target.value === '' || !Number.isInteger(value) || value < 0 || value > max;
      if (!draftInvalid) {
        states[index].quantity = value;
        notice = '';
      } else {
        notice = 'Maximum for this colour and size: ' + max + '. Check the remaining pack and available stock.';
      }
      syncStatus();
    });

    choicesEl.addEventListener('click', function (event) {
      var action = event.target.closest('[data-pack-bulk-add], [data-pack-bulk-minus], [data-pack-bulk-plus], [data-pack-bulk-remove]');
      if (!action) return;
      notice = '';
      draftInvalid = false;
      if (action.matches('[data-pack-bulk-add]')) {
        if (total() >= target) return;
        states.push({ colour: '', size: '', quantity: 0 });
        render();
        var newColour = choicesEl.querySelector('[data-pack-bulk-line]:last-child [data-pack-bulk-colour]');
        if (newColour) newColour.focus();
        return;
      }
      var line = action.closest('[data-pack-bulk-line]');
      var index = Number(line.getAttribute('data-line-index'));
      if (action.matches('[data-pack-bulk-remove]')) {
        states.splice(index, 1);
        if (!states.length) states.push({ colour: '', size: '', quantity: 0 });
      } else if (action.matches('[data-pack-bulk-plus]') && states[index].quantity < maximum(index)) {
        states[index].quantity += 1;
      } else if (action.matches('[data-pack-bulk-minus]') && states[index].quantity > 0) {
        states[index].quantity -= 1;
      }
      render();
    });

    if (toggle && editor) {
      toggle.addEventListener('click', function () {
        var open = !editor.hidden;
        editor.hidden = open;
        toggle.textContent = open ? toggle.getAttribute('data-label-edit') : toggle.getAttribute('data-label-done');
        toggle.setAttribute('aria-expanded', String(!open));
      });
    }
    row.ffcVariantIds = function () {
      if (!validSelection()) return [];
      var ids = [];
      states.forEach(function (state) {
        var variant = variantFor(state);
        for (var n = 0; variant && n < state.quantity; n++) ids.push(String(variant.id));
      });
      return ids;
    };
    row.ffcSelectedColours = function () {
      return unique(states.filter(function (state) { return state.quantity > 0; }).map(function (state) { return state.colour; }).filter(Boolean));
    };
    row.ffcValidateSelection = function () {
      draftInvalid = !domQuantitiesValid();
      if (!validSelection() && !notice) notice = 'Assign all ' + target + ' garments before continuing.';
      syncStatus();
    };
    render();
  }

  /* ---- jeden wiersz składu ------------------------------------------- */

  function setupRow(row) {
    var dataEl = row.querySelector('[data-pack-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    var qty = parseInt(row.getAttribute('data-qty'), 10);
    qty = qty > 0 ? qty : 1;
    if (row.hasAttribute('data-pack-bulk')) {
      setupBulkRow(row, variants, qty);
      return;
    }
    var sharedColour = row.querySelector('[data-pack-shared-colour]');
    var allColour = row.querySelector('[data-pack-all-colour]');
    var allSize = row.querySelector('[data-pack-all-size]');
    var choicesEl = row.querySelector('[data-pack-choices]');
    var summaryEl = row.querySelector('[data-pack-summary]');
    var readyEl = row.querySelector('[data-pack-ready]');
    var editor = row.querySelector('[data-pack-editor]');
    var toggle = row.querySelector('[data-pack-toggle]');
    var img = row.querySelector('[data-pack-img]');
    var originalImage = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.alt } : null;
    var productName = row.querySelector('.ffc-packrow__name');
    var stockEl = row.querySelector('[data-pack-stock]');
    var OUT = ' — out of stock';
    var colours = unique(variants.map(function (v) { return v.colour; }).filter(Boolean));
    var sizes = unique(variants.map(function (v) { return v.size; }).filter(Boolean));
    var states = [];
    var validationRequested = false;

    if (!choicesEl) return;

    function unique(values) {
      return values.filter(function (value, index) { return values.indexOf(value) === index; });
    }

    function live(v) {
      return v && v.available && Number(v.qty) > 0;
    }

    function exactVariant(state) {
      if (!state || (colours.length && !state.colour) || (sizes.length && !state.size)) return null;
      return variants.filter(function (v) {
        return (!colours.length || v.colour === state.colour) &&
          (!sizes.length || v.size === state.size);
      })[0];
    }

    function colourImage(state) {
      if (colours.length && !state.colour) return '';
      var exact = exactVariant(state);
      if (exact && exact.img) return exact.img;
      var match = variants.filter(function (v) {
        return (!colours.length || v.colour === state.colour) && v.img;
      })[0];
      return match ? match.img : '';
    }

    function usedBefore(variantId, index) {
      var used = 0;
      for (var i = 0; i < index; i++) {
        var prior = exactVariant(states[i]);
        if (prior && String(prior.id) === String(variantId)) used += 1;
      }
      return used;
    }

    function selectableFor(v, index) {
      return live(v) && usedBefore(v.id, index) < Number(v.qty);
    }

    function initialise() {
      markGlobalColours();
      for (var i = 0; i < qty; i++) {
        states.push({ colour: '', size: '' });
      }
    }

    /* Kolor bez ani jednego dostępnego wariantu jest wyszarzony i podpisany,
       a nie ukryty: klient szukający czerwieni ma zobaczyć, że ją mamy, tylko
       chwilowo nie ma jej na stanie. Ukrycie wygląda jak brak w ofercie. */
    function markGlobalColours() {
      if (!allColour) return;
      Array.prototype.forEach.call(allColour.options, function (opt) {
        if (!opt.value) return;
        var inColour = variants.filter(function (v) { return v.colour === opt.value; });
        var colourLive = inColour.some(live);
        opt.disabled = !colourLive;
        opt.textContent = colourLive ? opt.value : opt.value + OUT;
      });
      allColour.value = '';
    }

    function optionsHtml(values, current, disabled) {
      return values.map(function (value) {
        var isDisabled = disabled(value);
        return '<option value="' + escapeHtml(value) + '"' +
          (value === current ? ' selected' : '') +
          (isDisabled ? ' disabled' : '') + '>' +
          escapeHtml(value + (isDisabled ? OUT : '')) + '</option>';
      }).join('');
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function colourAvailable(colour, index) {
      return variants.some(function (v) {
        return v.colour === colour && selectableFor(v, index);
      });
    }

    function sizeAvailable(size, colour, index) {
      var variant = variants.filter(function (v) {
        return (!colours.length || v.colour === colour) && v.size === size;
      })[0];
      return selectableFor(variant, index);
    }

    function renderChoices(changedIndex) {
      var focusedId = document.activeElement && document.activeElement.id;
      // Clear invalid choices; never silently substitute a different size or colour.
      states.forEach(function (state, index) {
        if (state.size && !sizeAvailable(state.size, state.colour, index)) state.size = '';
      });
      if (allSize) {
        allSize.innerHTML = '<option value="">' + escapeHtml(row.dataset.allSizesLabel || 'Set all sizes') + '</option>' +
          optionsHtml(sizes.filter(function (size) {
            return states.some(function (state, index) { return sizeAvailable(size, state.colour, index); });
          }), '', function () { return false; });
        allSize.disabled = colours.length > 0 && states.some(function (state) { return !state.colour; });
      }
      if (allColour && sharedColour) {
        allColour.disabled = !sharedColour.checked;
        allColour.closest('label').hidden = !sharedColour.checked;
      }
      choicesEl.innerHTML = states.map(function (state, index) {
        var id = 'Pack-' + row.closest('[data-ffc-packcfg]').dataset.sectionId + '-' + row.dataset.rowIndex + '-' + index;
        var garment = (row.dataset.garmentLabel || 'Garment') + ' ' + (index + 1);
        var colourSelect = '';
        if (colours.length && (!sharedColour || !sharedColour.checked)) {
          colourSelect = '<div class="ffc-ux-field"><label for="' + id + '-colour">' + escapeHtml(garment + ' — ' + (row.dataset.colourLabel || 'Colour')) + '</label>' +
            '<select id="' + id + '-colour" class="ffc-packrow__select" data-pack-choice-colour required>' +
            '<option value=""' + (!state.colour ? ' selected' : '') + '>' + escapeHtml(row.dataset.chooseColour || 'Choose a colour') + '</option>' +
            optionsHtml(colours, state.colour, function (colour) { return !colourAvailable(colour, index) && colour !== state.colour; }) + '</select></div>';
        }
        var sizeSelect = '';
        if (sizes.length) {
          var offeredSizes = sizes.filter(function (size) { return sizeAvailable(size, state.colour, index); });
          var needsColour = colours.length > 0 && !state.colour;
          sizeSelect = '<div class="ffc-ux-field"><label for="' + id + '-size">' + escapeHtml(garment + ' — ' + (row.dataset.sizeLabel || 'Size')) + '</label>' +
            '<select id="' + id + '-size" name="' + id + '-size" class="ffc-packrow__select" data-pack-choice-size required' + (needsColour ? ' disabled' : '') + '>' +
            '<option value=""' + (!state.size ? ' selected' : '') + '>' + escapeHtml(needsColour ? (row.dataset.colourFirst || 'Choose a colour first') : (row.dataset.chooseSize || 'Choose a size')) + '</option>' +
            optionsHtml(offeredSizes, state.size, function () { return false; }) + '</select></div>';
        }
        var imageSrc = colourImage(state);
        var imageAlt = [productName ? productName.textContent.trim() : garment, state.colour, garment].filter(Boolean).join(' — ');
        var preview = imageSrc ? '<button type="button" class="ffc-packchoice__preview" data-pack-zoom aria-label="' + escapeHtml(imageAlt) + '">' +
          '<img data-pack-choice-img src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(imageAlt) + '" width="84" height="104" loading="lazy">' +
          '<span>' + escapeHtml(state.colour) + '</span></button>' : '';
        return '<div class="ffc-packchoice' + (imageSrc ? ' has-preview' : '') + '" data-pack-choice data-choice-index="' + index + '">' +
          '<strong class="ffc-packchoice__number">' + (index + 1) + '</strong>' +
          preview + '<div class="ffc-packchoice__controls">' + colourSelect + sizeSelect + '</div></div>';
      }).join('');

      choicesEl.querySelectorAll('[data-pack-choice-colour]').forEach(function (select) {
        select.addEventListener('change', function () {
          var choice = select.closest('[data-pack-choice]');
          var index = Number(choice.getAttribute('data-choice-index'));
          states[index].colour = select.value;
          states[index].size = ''; // A changed colour needs a new explicit size choice.
          renderChoices(index);
        });
      });
      choicesEl.querySelectorAll('[data-pack-choice-size]').forEach(function (select) {
        select.addEventListener('change', function () {
          var choice = select.closest('[data-pack-choice]');
          var index = Number(choice.getAttribute('data-choice-index'));
          states[index].size = select.value;
          renderChoices(index);
        });
      });

      var ready = 0;
      Array.prototype.forEach.call(choicesEl.querySelectorAll('[data-pack-choice]'), function (choice, index) {
        var chosen = exactVariant(states[index]);
        var valid = selectableFor(chosen, index);
        if (valid) {
          choice.setAttribute('data-variant-id', String(chosen.id));
          choice.setAttribute('data-colour', String(chosen.colour || ''));
          ready += 1;
        } else {
          choice.removeAttribute('data-variant-id');
          choice.removeAttribute('data-colour');
          choice.classList.toggle('is-unavailable', validationRequested || !!chosen);
        }
      });

      var uniform = states.every(function (state) { return state.colour === states[0].colour; });
      row.classList.toggle('has-mixed-colours', !uniform);
      if (img && originalImage) {
        var sharedImage = uniform ? colourImage(states[0]) : '';
        img.src = sharedImage || originalImage.src;
        img.alt = sharedImage ? [productName ? productName.textContent.trim() : originalImage.alt, states[0].colour].filter(Boolean).join(' — ') : originalImage.alt;
        if (!sharedImage && originalImage.srcset) img.setAttribute('srcset', originalImage.srcset);
        else img.removeAttribute('srcset');
      }
      updateStatus(ready);
      if (focusedId) {
        var focusedField = document.getElementById(focusedId);
        if (focusedField && choicesEl.contains(focusedField)) focusedField.focus({ preventScroll: true });
      }
    }

    function updateStatus(ready) {
      var sizeCounts = {};
      var colourCounts = {};
      states.forEach(function (state) {
        if (state.size) sizeCounts[state.size] = (sizeCounts[state.size] || 0) + 1;
        if (state.colour) colourCounts[state.colour] = (colourCounts[state.colour] || 0) + 1;
      });
      var sizeSummary = sizes.filter(function (size) { return sizeCounts[size]; }).map(function (size) {
        return size + ' ×' + sizeCounts[size];
      }).join(' · ');
      var selectedColours = Object.keys(colourCounts);
      var colourSummary = selectedColours.length === 1 ? selectedColours[0] : (selectedColours.length > 1 ? 'Mixed colours' : '');
      if (summaryEl) {
        summaryEl.textContent = [colourSummary, sizeSummary].filter(Boolean).join(' · ');
        summaryEl.hidden = !summaryEl.textContent;
      }
      if (readyEl) {
        readyEl.textContent = ready + '/' + qty + ' ready';
        readyEl.classList.toggle('is-incomplete', ready !== qty);
      }
      if (stockEl) {
        stockEl.hidden = ready === qty || !validationRequested;
        stockEl.textContent = stockEl.hidden ? '' : (row.dataset.chooseAllMessage || 'Choose a colour and size for every garment.');
        stockEl.className = 'ffc-packrow__stock ffc-packrow__stock--none';
      }
      row.setAttribute('data-selection-ready', ready === qty ? 'true' : 'false');
      var readinessEvent = document.createEvent('Event');
      readinessEvent.initEvent('ffc:pack-selection-change', true, false);
      row.dispatchEvent(readinessEvent);
    }

    if (sharedColour) {
      sharedColour.addEventListener('change', function () {
        if (sharedColour.checked && allColour) {
          var uniformColour = states[0].colour;
          allColour.value = states.every(function (state) { return state.colour === uniformColour; }) ? uniformColour : '';
          states.forEach(function (state) { if (state.colour !== allColour.value) state.size = ''; state.colour = allColour.value; });
        }
        renderChoices(-1);
      });
    }
    if (allColour) {
      allColour.addEventListener('change', function () {
        if (sharedColour && sharedColour.checked) {
          states.forEach(function (state) { if (state.colour !== allColour.value) state.size = ''; state.colour = allColour.value; });

          renderChoices(-1);
        }
      });
    }
    if (allSize) {
      allSize.addEventListener('change', function () {
        if (!allSize.value) return;
        states.forEach(function (state) { state.size = allSize.value; });
        allSize.value = '';
        renderChoices(-1);
      });
    }
    if (toggle && editor) {
      toggle.addEventListener('click', function () {
        var open = !editor.hidden;
        editor.hidden = open;
        toggle.textContent = open ? toggle.getAttribute('data-label-edit') : toggle.getAttribute('data-label-done');
        toggle.setAttribute('aria-expanded', String(!open));
      });
    }

    row.ffcValidateSelection = function () {
      validationRequested = true;
      // Reconcile the DOM with the stock-backed state before collecting actual IDs.
      choicesEl.querySelectorAll('[data-pack-choice-size]').forEach(function (select, index) {
        states[index].size = select.value;
      });
      renderChoices(-1);
    };
    initialise();
    renderChoices(0);
  }

  function setupSpecDialogs(root) {
    root.querySelectorAll('[data-pack-row]').forEach(function (row) {
      var opener = row.querySelector('[data-pack-spec-open]');
      var dialog = row.querySelector('[data-pack-spec-dialog]');
      var close = row.querySelector('[data-pack-spec-close]');
      if (!opener || !dialog || !close) return;

      opener.addEventListener('click', function () {
        dialog.showModal();
      });
      close.addEventListener('click', function () {
        dialog.close();
      });
      dialog.addEventListener('close', function () {
        opener.focus();
      });
    });
  }

  /* ---- podgląd zdjęcia ------------------------------------------------ */

  function setupLightbox(root) {
    var box = root.querySelector('[data-pack-lightbox]');
    if (!box) return;
    var boxImg = box.querySelector('[data-pack-lightbox-img]');
    var closeBtn = box.querySelector('[data-pack-lightbox-close]');
    var opener = null;

    function open(src, alt) {
      if (!src) return;
      // Zdjęcie w wierszu jest małe; do podglądu prosimy Shopify o wersję
      // dużą, podmieniając parametr szerokości w adresie CDN.
      boxImg.src = src.replace(/([?&]width=)\d+/, '$11400');
      boxImg.alt = alt || '';
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      box.hidden = true;
      boxImg.src = '';
      document.body.style.overflow = '';
      if (opener) opener.focus();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pack-zoom]');
      if (!trigger || !root.contains(trigger)) return;
      var i = trigger.querySelector('img');
      opener = trigger;
      if (i) open(i.currentSrc || i.src, i.alt);
    });

    closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  window.FFCPackConfiguratorV2 = {
    buildGroupedItems: buildGroupedItems,
    buildTransformParentItem: buildTransformParentItem
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
